import { RootState } from '..';

export const loginPendingSelector = (state: RootState) => state.auth.loginPending;
export const loginErrorSelector = (state: RootState) => state.auth.loginError;
export const userSelector = (state: RootState) => state.auth.user;
export const userInfoSelector = (state: RootState) => state.auth.user?.userInfo;
export const userTypeSelector = (state: RootState) => state.auth.user?.userInfo?.type;
export const tableViewSelector = (state: RootState) => state.auth.tableView;
